import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { MessageService } from 'primeng/api';
import { FloatLabel } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputOtpModule } from 'primeng/inputotp';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { AuthService } from 'src/app/public/services/auth.service';
import { DividerModule } from 'primeng/divider';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-reset',
  imports: [CommonModule,ReactiveFormsModule,FormsModule,MessageModule,
     MatFormFieldModule,
     MatInputModule,
     MatIconModule,
     InputTextModule,
     InputIconModule,
     IconFieldModule,
     InputOtpModule,
     DividerModule,
     PasswordModule,
     ToastModule
   ],
  templateUrl: './reset.component.html',
  styleUrl: './reset.component.scss',
  providers: [MessageService]
})
export class ResetComponent {
  submitted = false;
  isLoading = false;
  token: any;
  decodedToken: any;
  buttonTitle = "Submit"
  isPasswordVisible = false;
  isConfirmPasswordVisible = false;
  value!: string;

  passwordCriteria = {
    lowercase: false,
    uppercase: false,
    numeric: false,
    minLength: false,
    noWhitespace: false
  };

  ngOnInit() {
    this.resetPasswordForm.get('password')?.valueChanges.subscribe(value => {
      this.passwordCriteria.lowercase = /[a-z]/.test(value);
      this.passwordCriteria.uppercase = /[A-Z]/.test(value);
      this.passwordCriteria.numeric = /[0-9]/.test(value);
      this.passwordCriteria.minLength = value.length >= 8;
      this.passwordCriteria.noWhitespace = !/\s/.test(value);

    });
  }

  password = new FormControl(null, [
    Validators.required,
    Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=\S+$).{8,}$/)
  ]);
  
  confirmPassword = new FormControl(null, [
    Validators.required,
    Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=\S+$).{8,}$/)
  ]);
  
  resetPasswordForm = this.formBuilder.group(
    {
      password: this.password,
      confirmPassword: this.confirmPassword,
    },
    {
      validator: this.ConfirmedValidator('password', 'confirmPassword'),
    }
  );



  constructor(private messageService: MessageService,private coreAuth: AuthService, private route: ActivatedRoute, private router: Router, private formBuilder: FormBuilder) {
    this.token = this.route.snapshot.paramMap.get('token');
    this.decodedToken = jwtDecode(this.token);

  }

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors['confirmedValidator']
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  get formError(): any {
    console.log(this.resetPasswordForm.controls)
    return this.resetPasswordForm.controls;
  }
  onSubmit() {
    this.submitted = true;
    if (this.resetPasswordForm.invalid) {
      return;
    }
    let param = {
      password: this.resetPasswordForm.get("confirmPassword")?.value,
      user_id: this.decodedToken.user_id,
      token: this.token
    }
    this.isLoading = true;
    this.buttonTitle = "Loading"
    this.coreAuth.resetPassword(param).subscribe({
      next: (res) => {

        this.buttonTitle = "Submit"
        this.isLoading = false;
        // this.toast.success(res.message, 'Success');
        
        this.router.navigate(['login']);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 
          'Password reset successfully'
           });
      },
      error: (e) => {
        this.buttonTitle = "Submit"
        this.isLoading = false;
      },
      complete: () => {
        this.buttonTitle = "Submit"
        this.isLoading = false;
      }
    })

  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  toggleConfirmPasswordVisibility() {
    this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
  }

}
